<template>
  
    <div class="configure_template">
      <NavigationBackButton />
      <div v-if="isLoading" class="loading-overlay">
        <div class="loader"></div>
      </div>
  
      <div v-else class="card rounded-top rounded-bottom">
        <div class="card-body">
          <docuseal-builder
            v-if="token"
            :key="builderKey"
            :token="token"
            :autosave="true"
            :with-upload-button="false"
            :with-sign-yourself-button="false"
            :with-send-button="false"
            :only-defined-fields="false"
            :sign-yourself-button="false"
            :add-document-button="false"
            :fields="combined_fields"
            :template-entity-type-id="template_entity_type_id"
            :roles="roles"
            @fields-update="on_fields_update"
            @error="on_builder_error"
          ></docuseal-builder>
          
        </div>
      </div>
    </div>
  </template>
  <script src="./configure_template.js"></script>
  

